<mat-selection-list #matSelection role="list" class="list-plantillas">
  <mat-list-option *ngFor="let usuariosPlantillaItem of dataUsuariosPlantilla" [value]="usuariosPlantillaItem">
    {{ usuariosPlantillaItem.IdUsuario + ' - ' + usuariosPlantillaItem.Nusuario }}
  </mat-list-option>
</mat-selection-list>
